var _circle, _path, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 601.5,
    cy: 122.5,
    r: 62.5,
    fill: "#17C7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.87 355.098C218.41 370.731 284.37 329.619 300.195 263.274C316.019 196.929 275.717 130.471 210.177 114.838C144.637 99.2054 78.6774 140.317 62.8527 206.663C47.028 273.008 87.3302 339.465 152.87 355.098Z",
    fill: "url(#loaderGradient3)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.626,
    cy: 634.5,
    rx: 164,
    ry: 165.5,
    fill: "#ED801B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient3",
    x1: 143.51,
    y1: 250.695,
    x2: 296.504,
    y2: 189.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.b13e3539f9d5ea01211f7eddddb22ac9c14e361d839711cbbf890c3d404f404f.svg";
export { ForwardRef as ReactComponent };